import Link from 'next/link';
import Footer from 'components/Dashboard/Footer';
import { GetPageLink } from '@/utility/getLinkPage';
import { useRouter } from 'next/router';

interface LayoutProps {
  children: React.ReactNode;
}

export default function ErrorPage(props: LayoutProps) {
  const router = useRouter();

  return (
    <div className="block">
      <div className="w-full">
        <Link href={GetPageLink('/', router.query)}>
          <a className="block text-left mr-0 whitespace-nowrap text-sm uppercase font-bold md:pb-7 md:pt-8 md:pr-8 md:pl-8 pr-6 pl-6 pb-4 pt-14 md:mb-0 mb-4">
            <img
              alt="logo-idn"
              src="/assets/images/logo_idn.svg"
              className="h-auto w-[40px] py-2 md:w-[41px] md:py-[10.5px]"
            />
          </a>
        </Link>
      </div>
      <div className="w-full max-w-full bg-white">
        <div className="flex md:pl-8 md:pr-8 md:pb-10 md:pt-0 pl-6 pr-6 pb-10 pt-4 mx-auto w-full md:min-h-dashboard-content min-h-dashboard-content-mobile">
          {props.children}
        </div>
      </div>
      <Footer />
    </div>
  );
}
